require('./bootstrap');
var WebUploader = require('webuploader');
var bootbox = require('bootbox');

const getCookiesObj = () => {
    return document.cookie
        .split(';')
        .reduce((f, sv)=> {
            let _sv = sv.trim()
                .split('=')
                .map(v => {
                    return v.trim()
                })
            f[_sv[0]] = _sv[1]
            return  f
        }, {})
}

/**
 * alert destroy confirm
 */
$(document).on('click', 'form.destroy button[type="submit"]', function(e){
    e.preventDefault();
    var $this = $(this),
        message = $this.data("confirm"),
        form = $this.parent('form');

    bootbox.confirm(message, function(result){
        if (result) {
            $(form).submit();
        }
    });
});

/**
 * redirect button
 */
$(document).on('click', '.redirect-btn', function(e){
    e.preventDefault();
    var $this = $(this);

    window.location.href = $this.data("href");
});

/**
 * report form submit button
 */
$(document).on('click', '#report-form-btn', function(e) {
    e.preventDefault();
    var reportForm = $('#report-form'),
        reportFormData = reportForm.serializeArray(),
        data={},
        appetizer = '',
        nap = '',
        mood = '',
        paticipant = '',
        html = '';

    for (var i=0; i < reportFormData.length; i++) {
        data[reportFormData[i]['name']] = reportFormData[i]['value']
    }

    switch (data['appetizer']) {
        case '1':
            appetizer = '<i class="fas fa-pizza-slice" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '2':
            appetizer = '<i class="fas fa-pizza-slice" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-pizza-slice" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '3':
            appetizer = '<i class="fas fa-pizza-slice" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-pizza-slice" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-pizza-slice" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
    }

    switch (data['nap']) {
        case '1':
            nap = '<i class="fas fa-splotch fa" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '2':
            nap = '<i class="fas fa-splotch fa" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-splotch fa" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '3':
            nap = '<i class="fas fa-splotch fa" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-splotch fa" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-splotch fa" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
    }

    switch (data['mood']) {
        case '1':
            mood = '<i class="fas fa-angry" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '2':
            mood = '<i class="far fa-meh-rolling-eyes" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '3':
            mood = '<i class="far fa-laugh-beam" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
    }

    switch (data['paticipant']) {
        case '1':
            paticipant = '<i class="fas fa-award" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '2':
            paticipant = '<i class="fas fa-award" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-award" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
        case '3':
            paticipant = '<i class="fas fa-award" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-award" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i><i class="fas fa-award" style="color: orange;margin-right: 2px;font-size: 1.1rem;" aria-hidden="true"></i>';
            break;
    }

    html += '<div class="container-fluid">' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.date+': </label><div class="col-8 col-sm-9">'+data['report_date']+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.appetizer+': </label><div class="col-8 col-sm-9">'+appetizer+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.napping+': </label><div class="col-8 col-sm-9">'+nap+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.mood+': </label><div class="col-8 col-sm-9">'+mood+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.participation+': </label><div class="col-8 col-sm-9">'+paticipant+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.activities+': </label><div class="col-8 col-sm-9">'+window.I18n[data['outing']]+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">'+window.I18n.milk+': </label><div class="col-8 col-sm-9">'+window.I18n[data['milk']]+'</div></div>' +
        '<div class="row"><label class="text-lg-right col-4 col-sm-3">Message: </label><div class="col-8 col-sm-9" style="word-break: break-all">'+data['message']+'</div></div>' +
        '</div>';

    bootbox.dialog({
        title: window.I18n.preview_report,
        message: html,
        size: 'large',
        onEscape: true,
        backdrop: true,
        buttons: {
            cancel: {
                label: window.I18n.cancel.toUpperCase(),
                className: 'btn-default',
                callback: function(){

                }
            },
            ok: {
                label: window.I18n.submit.toUpperCase(),
                className: 'btn-primary',
                callback: function(){
                    reportForm.submit();
                }
            }
        }
    })
});

var selectUploaderImage = $('#selectUploaderImage');
if (selectUploaderImage.length > 0) {
    // init Web Uploader
    var uploader = WebUploader.create({

        // auto upload after selected.
        auto: true,

        // upload api
        server: selectUploaderImage.data('url') || '',


        pick: '#selectUploaderImage',

        // only image
        accept: {
            title: 'Images',
            extensions: 'gif,jpg,jpeg,bmp,png',
            mimeTypes: 'image/*'
        }
    });

    var imgElem = selectUploaderImage.data('imgelem'),
        inputElem = selectUploaderImage.data('inputelem');
    if (imgElem) {
        var $img = $(imgElem);
    }
    if (inputElem) {
        var $input = $(inputElem);
    }
    uploader.on( 'fileQueued', function( file ) {
        if (imgElem) {
            var $img = $(imgElem);
            $img.parent().addClass('position-relative');
            $img.parent().append('<div style="position: absolute;top: 0;left: 0; right: 0; bottom: 0;opacity:0.8;" class="selectThumbLoading bg-gradient-light"><div class="spinner-border position-relative" style="top: 45%;" role="status"><span class="sr-only">Loading...</span> </div></div>')
        }
    });

    uploader.on( 'uploadSuccess', function( file, responce ) {
        if ($img) {
            // create thumb
            // don't support IE6、IE7
            uploader.makeThumb( file, function( error, src ) {
                if ( error ) {
                    $img.replaceWith('<span>不能预览</span>');
                    return;
                }

                $img.attr( 'src', src );
            }, 1, 1);

            if ($input && responce.hasOwnProperty('path')) {
                $input.val(responce.path);
            }
        }
    });

    uploader.on( 'uploadError', function( file ) {
        if ($img) {
            var $error = $img.parent().find('.error');

            if ( !$error.length ) {
                $error = $('<div class="alert alert-danger" style="position: absolute;top: 0;left: 0;right: 0;" role="alert"></div>');
                $img.parent().addClass('position-relative');
                $img.parent().append($error);
            }

            $error.text('Upload failed.');

            setTimeout(function(){
                $error.remove()
            }, 2000)
        }
    });

    uploader.on('uploadComplete', function( file ) {
        if($img) {
            $img.parent().find('.selectThumbLoading').remove()
        }
    })
}
